import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Tooltip from 'components/Tooltip';
import { thunkFetchEventGroups } from '@/redux/actions';
import EventGroupsPicker from './EventGroupsPicker';
import './EventGroupsPicker.scss';

const EventGroupsPickerContainer = props => {
	const { groups, eventID, event, fetchGroups } = props;
	const id = eventID ? eventID : event.id;

	useEffect(() => {
		grabData('EventGroupsPicker.useEffect');
	}, []);

	const grabData = from => fetchGroups(id, from);
	const tooltip = (
		<div>
			Create a new group <Link to={`/events/${id}/groups`}>here</Link>
		</div>
	);

	return groups && groups.length ? (
		<EventGroupsPicker {...props} groups={groups} />
	) : (
		<div className="EventGroupsPicker-no-groups">
			<span>There are no groups for this event</span>
			<Tooltip content={tooltip} />
		</div>
	);
};

const msp = ({ groups }) => ({
	groups: groups.groups,
});

const mdp = dispatch => ({
	fetchGroups: (eventID, from) => dispatch(thunkFetchEventGroups(eventID, null, from)),
});

export default connect(msp, mdp)(EventGroupsPickerContainer);
